import { Box } from "@mui/material";
import { TextVariant } from "../Field/Text";
import { HeadingLevel, MaterialColors } from "@/core/types/types";
import ProgressBar from "./ProgressBar";
import { useTranslations as t } from "@/core/hooks/useTranslations/useTranslations";

type ProgressWrapperProps = {
  progressText?: string;
  progressTextColor: MaterialColors;
  progressPercentage?: string;
};

const ProgressBarWithText = ({
  progressText,
  progressTextColor,
  progressPercentage,
}: ProgressWrapperProps) => {
  return (
    <Box display="flex" flexDirection="column" my={2} gap={0.5}>
      {progressText && (
        <TextVariant
          text={t(progressText)}
          variant={HeadingLevel.H3}
          color={progressTextColor}
        />
      )}
      {progressPercentage && (
        <ProgressBar progressPercentage={progressPercentage} />
      )}
    </Box>
  );
};

export default ProgressBarWithText;
